import { render, staticRenderFns } from "./UserAttestations.vue?vue&type=template&id=0be9771f&scoped=true&"
import script from "./UserAttestations.vue?vue&type=script&lang=js&"
export * from "./UserAttestations.vue?vue&type=script&lang=js&"
import style0 from "./UserAttestations.vue?vue&type=style&index=0&id=0be9771f&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be9771f",
  null
  
)

export default component.exports